/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-01-25 14:05:30
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { TextStyle } from '@shopify/polaris';
import Banner from 'src/components/views/common/banners/pfs-banner-custom';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { getShop } from 'src/helpers';
import { URL } from 'src/constants/links';
import imageBanner from 'src/assets/images/banners/sync-info-banner.svg';
import waveIcon from 'src/assets/images/common/wave-icon.png';
import Hyperlink from 'src/components/views/common/hyperlink';

type State = {
  activeInfoBanner: boolean
};

class DidYouKnow extends Component<WithI18nProps, State> {
  state = {
    activeInfoBanner: true
  };

  componentDidMount() {
    // Check show info banner
    let dismiss = false;
    try {
      dismiss = localStorage.getItem(`${getShop()}-dismissSyncBanner`);
    } catch (error) {}

    // If the banner is dismissed, hide it
    if (dismiss === 'true') {
      this.setState(({ activeInfoBanner }) => ({ activeInfoBanner: !activeInfoBanner }));
    }
  }

  render() {
    const { activeInfoBanner } = this.state;
    const { i18n } = this.props;
    return (
      activeInfoBanner && (
        <Banner
          name="syncInfoBanner"
          title={i18n.translate('AdminHTML.Sync.DidYouKnow.bannerTitle')}
          titleIcon="book"
          status="info"
          image={imageBanner}
          backgroundImage={waveIcon}
          allowDismiss={true}
          onDismiss={this.handleDismissInfoBanner}>
          <div className="did-you-know">
            <p>
              <TextStyle>
                {i18n.translate('AdminHTML.Sync.DidYouKnow.text1', {
                  t1: (
                    <Hyperlink
                      url={URL.SyncDoc}
                      text={i18n.translate('AdminHTML.Sync.DidYouKnow.text1_t1')}
                    />
                  )
                })}
              </TextStyle>
            </p>
            <p style={{ marginTop: '1.25rem' }}>
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.Common.Title.important')}
              </TextStyle>{' '}
              <TextStyle>
                {i18n.translate('AdminHTML.Sync.DidYouKnow.text2', {
                  t1: (
                    <Hyperlink
                      url={URL.SyncDocBoostAllCollection}
                      text={i18n.translate('AdminHTML.Sync.DidYouKnow.text2_t1')}
                    />
                  )
                })}
              </TextStyle>
            </p>
          </div>
        </Banner>
      )
    );
  }

  // Handle dismiss info banner
  handleDismissInfoBanner = () => {
    try {
      localStorage.setItem(`${getShop()}-dismissSyncBanner`, 'true');
    } catch (error) {}
    this.setState(({ activeInfoBanner }) => ({ activeInfoBanner: !activeInfoBanner }));
  };
}

export default withI18n()(DidYouKnow);
